const dateLocation = [
  {
    id: '0',
    anime: 'Pom Poko',
    year: '1994',
    name: 'Abandoned House',
    info: 'The Tanukis of Tama Hills use this house as their base, where they plan their jump scare on humans. Other habitats of the Tanukis also include Tokyo, Tokyo\'s outer quarter, Shikoku and Fujino.',
    img: '00',
    game: true,
  },
  {
    id: '1',
    anime: 'Porco Rosso',
    year: '1992',
    name: 'Adriatic Sea',
    info: 'Much of the film Porco Rosso, save for when Porco went to Milan, takes place in the Adriatic Sea, between Italy and the former Yugoslavia. Porco lived on an island on the Croatian shoreline of the Adriatic Sea.',
    img: '01',
    game: false,
  },
  {
    id: '2',
    anime: 'The Tale of the Princess Kaguya',
    year: '2013',
    name: 'Bamboo Forest',
    info: 'The forest is located near the Village in the Woods. Sanuki no Miyatsuko works here everyday to cut bamboos. He makes a lot of different things out of it. The cottage of his family is at the bottom of a mountain. There is a forest border to the bamboo forest.',
    img: '02',
    game: true,
  },
  {
    id: '3',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Bathhouse',
    info: 'The Bathhouse, which stands on a half-dried swamp is a very grandiose and opulent structure on the island Yūya in the Spirit Realm.',
    img: '03',
    game: true,
  },
  {
    id: '4',
    anime: 'Spirited Away',
    year: '2001',
    name: 'The Boiler Room',
    info: 'Located below ground and can be accessed by side stairs jutting outside the exterior of The Bathhouse, the Boiler Room is home to Kamajī and countless Susuwatari (soot sprites).',
    img: '04',
    game: false,
  },
  {
    id: '5',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Bus Stop',
    info: 'The girls wait for their father Tatsuo Kusakabe to arrive by bus. Suddenly Totoro stands next to them with a big leaf on his head. Satsuki handover father\'s umbrella to him. Totoro takes it. Soon it surprises about the raining sound splashing on his umbrella.',
    img: '05',
    game: true,
  },
  {
    id: '6',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Camphor Tree',
    info: 'Mei Kusakabe falls into the tree\'s roots and enters an opening, where Totoro is sleeping. She becomes curious and sits on his belly, laughing at him as he sneezes in his sleep.',
    img: '06',
    game: true,
  },
  {
    id: '7',
    anime: 'The Cat Returns',
    year: '2002',
    name: 'Cat Kingdom',
    info: 'The Cat Kingdom is a world parallel to the human world, simply inhabited by cats. The Cat King rules the Cat Kingdom. Common cats don\'t wear clothes, except for noble cats. The cats eat mice and fish. At the castle, the variety of food is much bigger.',
    img: '07',
    game: false,
  },
  {
    id: '8',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Cave of Mind',
    info: 'In my concept art, I experimented with turning Howl\'s room into a cave. Sophie is holding a candle so I tried incorporating its light, but Miyazaki said, \'No, I want you to treat it as a mental image\'.',
    img: '08',
    game: false,
  },
  {
    id: '9',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Cedar Forest',
    info: 'The forest is protected by Moro\'s clan and the Boar clan against humans. The forest is old and healthy, seen by the number of Kodamas. Maybe it is over 70 million years old, because you find Coelacanths in the Sea of the Forest Spirit, which is also a holy place for the inhabitants.',
    img: '0999',
    game: false,
  },
  // новая 10
  {
    id: '10',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Cesari\'s',
    info: 'Cesari\'s is a bustling café located in the town plaza of Market Chipping. The café is adorned with stained glass windows and large decorative plants and fixtures, and even includes a confectionary where Lettie sells chocolates to the café patrons.',
    img: '010',
    game: false,
  },
  {
    id: '11',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Swamp Bottom',
    info: 'Swamp Bottom is the sixth stop the train Chihiro takes from the Bathhouse. Travelers arrive at the Swamp Bottom station platform with the clock post.',
    img: '011',
    game: false,
  },
  {
    id: '12',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Clock Tower',
    info: 'The Clock Tower is a structure accessible through the Red Gate. It acts as a gateway Chihiro and her family travel through to enter the other world.',
    img: '012',
    game: false,
  },
  {
    id: '13',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Clock Tower (Koriko)',
    info: 'The clock tower is one of Koriko\'s most iconic landmarks. Located in a town\'s central plaza, it is one of the first things Kiki sees as she descends to the city streets. The tower is manned by the Clock Tower Caretaker.',
    img: '013',
    game: false,
  },
  {
    id: '14',
    anime: 'From Up on Poppy Hill',
    year: '2011',
    name: 'Coquelicot Manor',
    info: 'The Garden consists of a large backyard where many flower beds are grown, and the flagpole that Umi always use whenever she hoist up her flag signals in honor of her father.',
    img: '014',
    game: false,
  },
  {
    id: '15',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Deserted Town',
    info: 'After Chihiro and her family exit the Clock Tower, they are led to the Deserted Town which resembles an old entertainment district, filled with seemingly abandoned small bars and restaurants.',
    img: '015',
    game: false,
  },
  {
    id: '16',
    anime: 'The Secret World of Arrietty',
    year: '2010',
    name: 'Dollhouse',
    info: 'He knew of the borrowers\' existence and he decided to make them a home. However, the borrowers lived in fear of the humans, and never lived in it. The dollhouse stands in Sho\'s bedroom.',
    img: '016',
    game: false,
  },
  {
    id: '17',
    anime: 'Tales from Earthsea',
    year: '2006',
    name: 'Earthsea',
    info: 'The world of Earthsea is one of sea and islands: a vast archipelago of hundreds of islands surrounded by mostly uncharted ocean. Earthsea contains no large continents, with the archipelago resembling Indonesia or the Philippines.',
    img: '017',
    game: false,
  },
  {
    id: '18',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Emishi Village',
    info: '500 years ago, the emperor Mikado chases them off to the forests. In the movie the location of the movie is never revealed to the viewer. Perhaps the village is located on the islands Shikoku, Kyushu or Cedar Forest.',
    img: '018',
    game: false,
  },
  {
    id: '19',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Gondoa',
    info: 'The first is an instance of narration, showing Sheeta wandering out from her home, accompanied by several beasts of burden, as she tells Pazu where she\'s from and what happened to her.',
    img: '019',
    game: false,
  },
  // следующая 10
  {
    id: '20',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Gütiokipänjä',
    info: 'The bakery and storefront can be found on the ground level, while Osono and her family\'s living quarters are on the second floor; they also provide a place for Kiki to stay in an old guest quarters.',
    img: '020',
    game: false,
  },
  {
    id: '21',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Hatter\'s Hat Shop',
    info: 'Located in Market Chipping, the Hatter\'s hat shop is owned by Sophie\'s father, who bequeathed it to her stepmother Honey. Sophie was left in charge of the shop.',
    img: '021',
    game: false,
  },
  {
    id: '22',
    anime: 'Ponyo',
    year: '2008',
    name: 'Himawari Nursery School',
    info: 'The nursery is located in Tomonoura next to Lisa\'s workplace, the Himawari Service Center. Sōsuke often crawls through a hole in the fence to get to the home for the elderly. Yoshie, Noriko and Toki are always happy to see him.',
    img: '022',
    game: false,
  },
  {
    id: '23',
    anime: 'Porco Rosso',
    year: '1992',
    name: 'Hotel Adriano',
    info: 'Hotel Adriano is located in a small island in Adriatic Sea, near the city Doburoku. The hotel exterior contains an ornate garden and a gazebo, and a dock for would-be guests. The hotel also includes a cafe and bar, where guests relax and occasionally listen to Gina\'s performances.',
    img: '023',
    game: false,
  },
  {
    id: '24',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Howl\'s Bedroom',
    info: 'Howl\'s personal sanctuary from the world. His bedroom is filled with wards, talismans and spells to hide his presence from those that seek him. The room is also filled with all manner of childhood toys and artifacts, many of which could be found in Howl\'s mind cave.',
    img: '024',
    game: false,
  },
  {
    id: '25',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Howl\'s Castle',
    info: 'The castle is quite different in the movie, depicted as a hodgepodge of houses, mechanics, and even cannon stations that form what appears to be a walking, mechanical creature with chicken-like legs and a huge, frog-like face. It retains the four smoke towers. Grandma Sophie, upon seeing the castle for the first time in the Wastelands, comments on its ugliness.',
    img: '025',
    game: false,
  },
  {
    id: '26',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Howl\'s Cottage',
    info: 'The cottage is simply and sparsely decorated, with Howl\'s desk at the center. The desk contains Howl\'s old books, a mug, a candle, writing material, letters and an old leaf. Outside the cottage is a waterwheel and the marshlands.',
    img: '026',
    game: false,
  },
  {
    id: '27',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Ingary',
    info: 'The country is a constitutional monarchy, ruled by a prime minister but reigned over by a king. In addition to the prime minister, the kingdom\'s cabinet included a minister of defense. Despite the kingdom\'s reliance on steam-powered technology for civilian and military use, they continue to employ wizards, all serving under a powerful sorceress named Suliman.',
    img: '027',
    game: false,
  },
  {
    id: '28',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Irontown',
    info: 'Lady Eboshi\'s militarism has resulted in an ideological clash with the rulers of the neighboring forest, resulting in San\'s repeated assassination attempts on her. Ashitaka arrives in town in the middle of this conflict and becomes fairly popular while working to help settle the dispute.',
    img: '028',
    game: false,
  },
  {
    id: '29',
    anime: 'The Wind Rises',
    year: '2013',
    name: 'Jiro Horikoshi\'s house',
    info: 'Around the house, there are paddy fields. The house is built out of three buildings. The family seems to be wealthy, because they have servants (with their own child) and Jiro can afford to study in Tokyo.',
    img: '029',
    game: false,
  },
  // новая 10 вопросов
  {
    id: '30',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Kanta\'s House',
    info: 'Kanta\'s House is a home of the family Ōgaki along with his grandmother Granny. The house is located in Matsugō; between the Bus Stop and Kusakabe\'s House.',
    img: '030',
    game: false,
  },
  {
    id: '31',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Karikiya',
    info: 'Karikiya is the hometown of Kiki and her family\'s residence.',
    img: '031',
    game: false,
  },
  {
    id: '32',
    anime: 'Ocean Waves',
    year: '1993',
    name: 'Kichijōji Station',
    info: 'Kichijoji Station is the station of Tokyo in film adaptation of Ocean Waves.',
    img: '032',
    game: false,
  },
  {
    id: '33',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Kingsbury',
    info: 'Kingsbury is the capital of the kingdom Ingary and featured in the film, Howl\'s Moving Castle.',
    img: '033',
    game: false,
  },
  {
    id: '34',
    anime: 'Grave of the Fireflies',
    year: '1988',
    name: 'Kobe',
    info: 'Kobe is a city in Japan.',
    img: '034',
    game: false,
  },
  {
    id: '35',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Koriko',
    info: 'When Kiki flies over the ocean by town, she sees the clock tower and meets the Clock Tower Caretaker. Down by the city, trams reminiscent of San Francisco ply the streets. There\'s a busy shopping district, a lively port area, a market, large open parks and quiet neighborhoods, many with a panoramic view of the sea. Osono\'s bakery Gütiokipänjä is located here.',
    img: '035',
    game: false,
  },
  {
    id: '36',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Kusakabe\'s House',
    info: 'The Kusakabe House is home to Satsuki, Mei and their parents (Tatsuo and Yasuko). The house was previously owned by Granny, who went to visit the family when they had just moved in, apologising for not being able to clean it before hand.',
    img: '036',
    game: false,
  },
  {
    id: '37',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Laputa',
    info: 'Laputa is the setting of the latter part of Castle in the Sky. As the name of the film suggests, Laputa is an immense castle floating on an island in the sky. The opening credits showcase the development of the technology by which this is possible.',
    img: '037',
    game: false,
  },
  {
    id: '38',
    anime: 'Pom Poko',
    year: '1994',
    name: 'Manpuku Temple',
    info: 'The Manpuku Temple is an abandoned temple in the Studio Ghibli film, Pom Poko. In the film it is where the raccoons gather and spend most of the film.',
    img: '038',
    game: false,
  },
  {
    id: '39',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Market Chipping',
    info: 'The city of Market Chipping borders the waste and mountain ranges that separate the neighboring kingdom. It is a vast industrial city filled with steam trolleys, automobiles, double-decker buses, a rail network and a lively town center. Sophie lives in her father\'s hat shop located in the industrial district. The popular café Cesari\'s can also be found in the town plaza.',
    img: '039',
    game: false,
  },
  // следующие 10 аниме
  {
    id: '40',
    anime: 'When Marnie Was There',
    year: '2014',
    name: 'Marsh house',
    info: 'The Marsh House is an abandoned house from the film When Marnie Was There. Marnie was born there, and lived there for most of her childhood. The Doi family moved in around the time Anna was visiting. Sayaka is part of the Doi family, and the house has Sayaka\'s Bedroom.',
    img: '040',
    game: false,
  },
  {
    id: '41',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Matsugō',
    info: 'Matsugo is the Japanese farm village where The Kusakabe family moving to the new house and work many Humans in the ricefield.',
    img: '041',
    game: false,
  },
  {
    id: '42',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Irontown',
    info: 'Irontown is a small settlement in Studio Ghibli\'s film Princess Mononoke and one of the primary settings. Ruled by Lady Eboshi, it is protected by a lake on one side and high walls surrounding its entirety.',
    img: '042',
    game: false,
  },
  {
    id: '43',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Nausicaä\'s Tower',
    info: 'Nausicaa\'s Tower is the home of main protagonist Nausicaä along with Teto her Fox Squirrel, and her father King Jhil (before he was killed by Tolumekians during the occupation).',
    img: '043',
    game: false,
  },
  {
    id: '44',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Okino Residence',
    info: 'The Okino Residence is located in the small town of Karikiya and is home to Kiki\'s family, which includes her father, Okino and her mother, Kokiri. The house is surrounded by gardens and flowers, and includes a sun room and a potion-making workshop. Kiki\'s bedroom room is located on the second floor.',
    img: '044',
    game: false,
  },
  {
    id: '45',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Pazu\'s Town',
    info: 'Pazu\'s Town (also called Slag Ravine or Pazu\'s Mines) is a location in Studio Ghibli\'s film Castle in the Sky.',
    img: '045',
    game: false,
  },
  {
    id: '46',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Pejite',
    info: 'Pejite is a country in Nausicaä of the Valley of the Wind. This was the city Asbel and Lastelle lived in, along with the rest of the population. It is later annihilated by Ohmu and other insects. The fate of Pejite is unknown at the end of the film, but is presumably forsaken by the people.',
    img: '046',
    game: false,
  },
  {
    id: '47',
    anime: 'Porco Rosso',
    year: '1992',
    name: 'Piccolo S.P.A',
    info: 'The garage has brown gate and sign that says Piccolo S.P.A. It is located in Milan, Italy.',
    img: '047',
    game: false,
  },
  {
    id: '48',
    anime: 'Pom Poko',
    year: '1994',
    name: 'Abandoned House',
    info: 'The Tanukis of Tama Hills use this house as their base, where they plan their jump scare on humans. Other habitats of the Tanukis also include Tokyo, Tokyo\'s outer quarter, Shikoku and Fujino.',
    img: '048',
    game: false,
  },
  {
    id: '49',
    anime: 'Porco Rosso',
    year: '1992',
    name: 'Porco\'s Hideout',
    info: 'A large limestone cove in an island located off the coast of the Croatian shoreline. Inspired by Stiniva Cove, Vis Island in Croatia, the area functions as Porco Rosso\'s base of operations in the Adriatic Sea. A number of amenities are available, including a tent, a radio transmitter and a harbor to dock Porco\'s Savoia S.21 seaplane.',
    img: '049',
    game: false,
  },
  /// новые 10 аниме
  {
    id: '50',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Porthaven',
    info: 'Porthaven is a major port for the military of Ingary. The Porthaven Marshes and the garden at the edge of the waste are merged into Howl\'s Secret Garden.',
    img: '050',
    game: false,
  },
  {
    id: '51',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Red Gate',
    info: 'The Red Gate is the entrance to the Clock Tower. Through the gate, the Ogino family arrives at the Deserted Town.',
    img: '051',
    game: false,
  },
  {
    id: '52',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Royal Palace',
    info: 'The old palace gate leads to a large plaza, where officers and society women enjoy rides on the flying kayak. The war has seemingly not affected the capital city of Kingsbury. Several magic talismans placed by the royal sorceress Suliman line the entrance and the colossal staircase leading to the palace, forbidding anything magical to enter. Inside the palace are winding rooms, one specially outfitted with powerful lamps meant to entrap the Witch of the Waste.',
    img: '052',
    game: false,
  },
  {
    id: '53',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Satsuki\'s School House',
    info: 'The first time it is mentioned, Michiko tells Satsuki it\'s time for school, and they must go. The second time is when Granny and Mei turn up. Mei refuses to be without Satsuki and won\'t stop crying, so Satsuki has to have Mei sit in on the lessons with her. The lesson continues with Mei sat between Satsuki and Michiko. Mei draws Totoro while she is there.',
    img: '053',
    game: false,
  },
  {
    id: '54',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Satsuki\'s School House',
    info: 'The first time it is mentioned, Michiko tells Satsuki it\'s time for school, and they must go. The second time is when Granny and Mei turn up. Mei refuses to be without Satsuki and won\'t stop crying, so Satsuki has to have Mei sit in on the lessons with her. The lesson continues with Mei sat between Satsuki and Michiko. Mei draws Totoro while she is there.',
    img: '054',
    game: false,
  },
  {
    id: '55',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Sea Railway',
    info: 'The Sea Railway is a railway used by the shadow-like denizens of the Spirit Realm, as seen in Spirited Away.',
    img: '055',
    game: false,
  },
  {
    id: '56',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Secret Garden',
    info: 'Like many things in the movie, this location seems to be a combination of several other prominent locations in the book, namely the Garden at the edge of The Waste (being a massive garden created by magic, used for the flower shop) and the Porthaven Marshes (a wetland where Howl catches Calcifer).',
    img: '057',
    game: false,
  },
  {
    id: '57',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Shichikokuyama Hospital',
    info: 'The Hospital is a recurring setting in My Neighbor Totoro. There, Mei and Satsuki\'s mother Yasuko Kusakabe is a patient while she is sick. She stays at the hospital throughout the entire film, but does return home during the end credits. It is thought that she is staying there due to the presence of tuberculosis. The hospital is revealed at the end of the movie when Satsuki and Mei arrive with Catbus. They are seen hiding in a tree while her mother and father talk.',
    img: '056',
    game: false,
  },
  {
    id: '58',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Spirit Realm',
    info: 'The Spirit Realm (霊界 reikai, lit. "spirit world") is the main setting for the Japanese animated film Spirited Away. It is home to the Bathhouse owned by Yubaba and the cottage owned by Zeniba, two of the film\'s core locations. Unlike the Human World, most of the Spirit Realm\'s occupants usually go about their activities at night rather than during the day.',
    img: '058',
    game: false,
  },
  {
    id: '59',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Market Chipping',
    info: 'The city of Market Chipping borders the waste and mountain ranges that separate the neighboring kingdom. It is a vast industrial city filled with steam trolleys, automobiles, double-decker buses, a rail network and a lively town center. Sophie lives in her father\'s hat shop located in the industrial district. The popular café Cesari\'s can also be found in the town plaza.',
    img: '059',
    game: false,
  },
  // новые 10 аниме
  {
    id: '60',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Swamp Bottom',
    info: 'Swamp Bottom is a location in the Spirit Realm seen in the film Spirited Away. Chihiro travels here via the Sea Railway from the Bathhouse train platform.',
    img: '060',
    game: false,
  },
  {
    id: '61',
    anime: 'Ponyo',
    year: '2008',
    name: 'Sōsuke\'s House',
    info: 'Sōsuke\'s House is his and his parents\' (Lisa and Koichi\'s) house. Later, Ponyo ends up living there, too.',
    img: '061',
    game: false,
  },
  {
    id: '62',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Tedus',
    info: 'Tedis is a coastal military fortification in Castle in the Sky. When Sheeta and Pazu are captured by the military, they are taken to Tedus. The fort is later partially destroyed by an ancient Laputian robot Sheeta inadvertently summons.',
    img: '062',
    game: false,
  },
  {
    id: '63',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'The Waste',
    info: 'The Waste is a location in the film, Howl\'s Moving Castle. It is a vast wasteland in the land of Ingary where no one dares to venture of their own free will. It is located in the south-western corner of the kingdom.',
    img: '063',
    game: false,
  },
  {
    id: '64',
    anime: 'Grave of the Fireflies',
    year: '1988',
    name: 'Tokyo',
    info: 'Tokyo is the capital of Japan and where Studio Ghibli was founded in 1985. It was seen in a few films.',
    img: '064',
    game: false,
  },
  {
    id: '65',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Torumekia',
    info: 'Torumekia is a large empire located to the east of the Toxic Jungle. Its capital city and the seat of the imperial throne is Tolas.',
    img: '065',
    game: false,
  },
  {
    id: '66',
    anime: 'My Neighbor Totoro',
    year: '1988',
    name: 'Kanta\'s House',
    info: 'Kanta\'s House is a home of the family Ōgaki along with his grandmother Granny. The house is located in Matsugō; between the Bus Stop and Kusakabe\'s House.',
    img: '066',
    game: false,
  },
  {
    id: '67',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Toxic Jungle',
    info: 'The Toxic Jungle is a vast, poisonous forest that appears in Nausicaä of the Valley of the Wind. It constantly threatens the areas where humans can live. The forest is filled with a deadly miasma that chokes all human and animal life. Only those wearing a Shohki Mask or an equivalent to one can hope to survive in this deadly place.',
    img: '067',
    game: false,
  },
  {
    id: '68',
    anime: 'Ponyo',
    year: '2008',
    name: 'Underwater harbor',
    info: 'Fujimoto\'s Underwater Harbor is a location in Studio Ghibli\'s film Ponyo. This is a home of Brunhilde before she named Ponyo and her father, before his good in the end of the film and his wife. She has also small sisters. But Ponyo catched in a bubble for coming out she says let me out! And then when her sisters help to be a human, she escape from a lair.',
    img: '068',
    game: false,
  },
  {
    id: '69',
    anime: 'Only Yesterday',
    year: '1991',
    name: 'Yamagata',
    info: 'Yamagata is a location in Studio Ghibli\'s film Only Yesterday.When Taeko and Toshio travel with his car to his house and Taeko and Toshio arrived his place.',
    img: '069',
    game: false,
  },
  // новые 10 аниме
  {
    id: '70',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Yubaba\'s Apartment',
    info: 'Yubaba\'s grand apartment is lined with giant vases on gold-plated pedestals, chandeliers, marbled floors, a grand fireplace, and luxurious carpeting and furnishings. The foyer includes an ornate, East-Asian style entrance lies beneath an emblem of the Bathhouse.',
    img: '070',
    game: false,
  },
  {
    id: '71',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Yubaba\'s Office',
    info: 'Yubaba\'s office, which is connected to her apartment, is decorated with an ornate, East Asian-style entrance.',
    img: '071',
    game: false,
  },
  {
    id: '72',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Zeniba\'s Cottage',
    info: 'Zeniba\'s home is a cozy, one-story, cottage down by Swamp Bottom. The interiors are done in a simply, western-style, contrasting her sister\'s more opulent apartment and office.',
    img: '072',
    game: false,
  },
  {
    id: '73',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Second Floor',
    info: 'The second floor is dedicated to traditional Japanese tatami-matted dining rooms for customers. It is first shown during Chihiro\'s elevator ride through the building complex with the Radish Spirit. A long hallway with rooms separated by rice paper wooden doors line the second floor. They also seem quite popular with customers, as seen when all rooms are occupied Chihiro arrives on the level.',
    img: '073',
    game: false,
  },
  {
    id: '74',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Ground Floor',
    info: 'The ground floor is seemingly dedicated to kitchens and customer-use baths. Due to their popular and constant use, some of the baths are notorious for being extremely dirty. During Chihiro\'s stay as a worker, she is assigned (with Lin) to clean the biggest and dirtiest tub on the ground floor, which, according to Lin, was one that hadn\'t been cleaned in months.',
    img: '074',
    game: false,
  },
  {
    id: '75',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Top Floor',
    info: 'The top floor has two doors, with the right one having a talking door knocker. The left door is never opened, but the right door is home to Yubaba\'s office and Boh\'s room. It is an opulently-built, largely unoccupied space lined with expensive vases accentuated by intricate architecture. Yubaba\'s office lies on this floor, conjoined with Boh\'s bedroom. Multiple large wooden doors, which close off at least four other rooms, block the path to Yubaba\'s office, followed by many.',
    img: '075',
    game: false,
  },
  {
    id: '76',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Deserted Town',
    info: 'After Chihiro and her family exit the Clock Tower, they are led to the Deserted Town which resembles an old entertainment district, filled with seemingly abandoned small bars and restaurants.',
    img: '076',
    game: false,
  },
  {
    id: '77',
    anime: 'The Secret World of Arrietty',
    year: '2010',
    name: 'Dollhouse',
    info: 'He knew of the borrowers\' existence and he decided to make them a home. However, the borrowers lived in fear of the humans, and never lived in it. The dollhouse stands in Sho\'s bedroom.',
    img: '077',
    game: false,
  },
  {
    id: '78',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Hatter\'s Hat Shop',
    info: 'Located in Market Chipping, the Hatter\'s hat shop is owned by Sophie\'s father, who bequeathed it to her stepmother Honey. Sophie was left in charge of the shop.',
    img: '078',
    game: false,
  },
  {
    id: '79',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Howl\'s Bedroom',
    info: 'Howl\'s personal sanctuary from the world. His bedroom is filled with wards, talismans and spells to hide his presence from those that seek him. The room is also filled with all manner of childhood toys and artifacts, many of which could be found in Howl\'s mind cave.',
    img: '079',
    game: false,
  },
  // новые 10 аниме
  {
    id: '80',
    anime: 'Princess Mononoke',
    year: '1997',
    name: 'Irontown',
    info: 'Lady Eboshi\'s militarism has resulted in an ideological clash with the rulers of the neighboring forest, resulting in San\'s repeated assassination attempts on her. Ashitaka arrives in town in the middle of this conflict and becomes fairly popular while working to help settle the dispute.',
    img: '080',
    game: false,
  },
  {
    id: '81',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Laputa',
    info: 'Laputa is the setting of the latter part of Castle in the Sky. As the name of the film suggests, Laputa is an immense castle floating on an island in the sky. The opening credits showcase the development of the technology by which this is possible.',
    img: '081',
    game: false,
  },
  {
    id: '82',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Market Chipping',
    info: 'The city of Market Chipping borders the waste and mountain ranges that separate the neighboring kingdom. It is a vast industrial city filled with steam trolleys, automobiles, double-decker buses, a rail network and a lively town center. Sophie lives in her father\'s hat shop located in the industrial district. The popular café Cesari\'s can also be found in the town plaza.',
    img: '082',
    game: false,
  },
  {
    id: '83',
    anime: 'Porco Rosso',
    year: '1992',
    name: 'Porco\'s Hideout',
    info: 'A large limestone cove in an island located off the coast of the Croatian shoreline. Inspired by Stiniva Cove, Vis Island in Croatia, the area functions as Porco Rosso\'s base of operations in the Adriatic Sea. A number of amenities are available, including a tent, a radio transmitter and a harbor to dock Porco\'s Savoia S.21 seaplane.',
    img: '083',
    game: false,
  },

  {
    id: '84',
    anime: 'Porco Rosso',
    year: '1992',
    name: 'Hotel Adriano',
    info: 'Hotel Adriano is located in a small island in Adriatic Sea, near the city Doburoku. The hotel exterior contains an ornate garden and a gazebo, and a dock for would-be guests. The hotel also includes a cafe and bar, where guests relax and occasionally listen to Gina\'s performances.',
    img: '084',
    game: false,
  },
  {
    id: '85',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Hatter\'s Hat Shop',
    info: 'Located in Market Chipping, the Hatter\'s hat shop is owned by Sophie\'s father, who bequeathed it to her stepmother Honey. Sophie was left in charge of the shop.',
    img: '085',
    game: false,
  },
  {
    id: '86',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Deserted Town',
    info: 'After Chihiro and her family exit the Clock Tower, they are led to the Deserted Town which resembles an old entertainment district, filled with seemingly abandoned small bars and restaurants.',
    img: '086',
    game: false,
  },
  {
    id: '87',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Clock Tower',
    info: 'The Clock Tower is a structure accessible through the Red Gate. It acts as a gateway Chihiro and her family travel through to enter the other world.',
    img: '087',
    game: false,
  },
  {
    id: '88',
    anime: 'Spirited Away',
    year: '2001',
    name: 'The Boiler Room',
    info: 'Located below ground and can be accessed by side stairs jutting outside the exterior of The Bathhouse, the Boiler Room is home to Kamajī and countless Susuwatari (soot sprites).',
    img: '088',
    game: false,
  },
  {
    id: '89',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Zeniba\'s Cottage',
    info: 'Zeniba\'s home is a cozy, one-story, cottage down by Swamp Bottom. The interiors are done in a simply, western-style, contrasting her sister\'s more opulent apartment and office.',
    img: '089',
    game: false,
  },

  // новые 10 аниме
  {
    id: '90',
    anime: 'Castle in the Sky',
    year: '1986',
    name: 'Tedus',
    info: 'Tedis is a coastal military fortification in Castle in the Sky. When Sheeta and Pazu are captured by the military, they are taken to Tedus. The fort is later partially destroyed by an ancient Laputian robot Sheeta inadvertently summons.',
    img: '090',
    game: false,
  },
  {
    id: '91',
    anime: 'Nausicaä of the Valley of the Wind',
    year: '1984',
    name: 'Toxic Jungle',
    info: 'The Toxic Jungle is a vast, poisonous forest that appears in Nausicaä of the Valley of the Wind. It constantly threatens the areas where humans can live. The forest is filled with a deadly miasma that chokes all human and animal life. Only those wearing a Shohki Mask or an equivalent to one can hope to survive in this deadly place.',
    img: '091',
    game: false,
  },
  {
    id: '92',
    anime: 'Ponyo',
    year: '2008',
    name: 'Koganei Maru',
    info: 'Koganei Maru is the ship where Kōichi (Sōsuke\'s father) works. He is the captain on it. The ship is seen in the film Ponyo directed by Hayao Miyazaki of Studio Ghibli. The ship is equipped with spotlights, the only way to talk to Kōichi\'s wife, Lisa, and his son, Sōsuke.',
    img: '092',
    game: false,
  },
  {
    id: '93',
    anime: 'Ponyo',
    year: '2008',
    name: 'Sōsuke\'s Boat',
    info: 'Sosuke\'s Boat is a toy boat that Sōsuke plays with. He\'s able to hold the boat in the beginning and later when Ponyo sees his boat and uses magic to make it big enough to ride in, Ponyo and Sosuke carry it outside his house. Sōsuke uses candles to make it move. He later steers this boat to find Lisa at the Senior Center.',
    img: '093',
    game: false,
  },
  {
    id: '94',
    anime: 'Only Yesterday',
    year: '1991',
    name: 'Yamagata',
    info: 'Yamagata is a location in Studio Ghibli\'s film Only Yesterday.When Taeko and Toshio travel with his car to his house and Taeko and Toshio arrived his place.',
    img: '094',
    game: false,
  },
  {
    id: '95',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Zeniba\'s Cottage',
    info: 'Zeniba\'s home is a cozy, one-story, cottage down by Swamp Bottom. The interiors are done in a simply, western-style, contrasting her sister\'s more opulent apartment and office.',
    img: '095',
    game: false,
  },
  {
    id: '96',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Bathhouse',
    info: 'The Bathhouse, which stands on a half-dried swamp is a very grandiose and opulent structure on the island Yūya in the Spirit Realm.',
    img: '096',
    game: false,
  },
  {
    id: '97',
    anime: 'Howl\'s Moving Castle',
    year: '2004',
    name: 'Cave of Mind',
    info: 'In my concept art, I experimented with turning Howl\'s room into a cave. Sophie is holding a candle so I tried incorporating its light, but Miyazaki said, \'No, I want you to treat it as a mental image\'.',
    img: '097',
    game: false,
  },
  {
    id: '98',
    anime: 'Spirited Away',
    year: '2001',
    name: 'Deserted Town',
    info: 'After Chihiro and her family exit the Clock Tower, they are led to the Deserted Town which resembles an old entertainment district, filled with seemingly abandoned small bars and restaurants.',
    img: '098',
    game: false,
  },
  {
    id: '99',
    anime: 'Kiki\'s Delivery Service',
    year: '1989',
    name: 'Gütiokipänjä',
    info: 'The bakery and storefront can be found on the ground level, while Osono and her family\'s living quarters are on the second floor; they also provide a place for Kiki to stay in an old guest quarters.',
    img: '099',
    game: false,
  },
];

export default dateLocation;
